import { Recipient } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

type PassedRecipientsState = {
  passedRecipients: Recipient[];
};

type PassedRecipientsActions = {
  setPassedRecipients: (passedRecipients: PassedRecipientsState['passedRecipients']) => void;
};

type PassedRecipientsStore = PassedRecipientsState & PassedRecipientsActions;

export const usePassedRecipientsStore = createStoreWithSubscribe<PassedRecipientsStore>(
  (set) => {
    return {
      passedRecipients: [],
      setPassedRecipients: (passedRecipients) => set((prevState) => ({ ...prevState, passedRecipients })),
    };
  },
  { name: 'PassedRecipientsStore' }
);

export const usePassedRecipientsShallowStore = createShallowStore(usePassedRecipientsStore);
